// Reorder buttons component for horizontal sections and cards
import { ArrowUp, ArrowDown } from 'lucide-react';

export default function ReorderButtons({ onMoveUp, onMoveDown, isFirst, isLast }) {
  return (
    <div className="flex flex-col gap-1 mr-3">
      <button 
        onClick={onMoveUp}
        disabled={isFirst}
        title="Move section up"
        className={`p-1 rounded ${isFirst ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-100'}`}
      >
        <ArrowUp className="w-4 h-4" />
      </button>
      <button 
        onClick={onMoveDown}
        disabled={isLast}
        title="Move section down"
        className={`p-1 rounded ${isLast ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-100'}`}
      >
        <ArrowDown className="w-4 h-4" />
      </button>
    </div>
  );
}
